import { __awaiter } from "tslib";
import axios from 'axios';
import { toFormData, toFormUrlEncoded } from './helpers';
export var DataType;
(function (DataType) {
    DataType[DataType["Json"] = 0] = "Json";
    DataType[DataType["FormUrlEncoded"] = 1] = "FormUrlEncoded";
    DataType[DataType["MultipartFormData"] = 2] = "MultipartFormData";
})(DataType || (DataType = {}));
export class HttpApi {
    constructor() {
        this.client = axios.create({
            withCredentials: true,
            // baseURL: '/',
        });
        this.client.interceptors.request.use(function onRequest(config) {
            // if (typeof process !== 'undefined') {
            //   // rewrite headers for all requests
            //   config.headers['Header'] = 'value'
            // }
            return config;
        }, function onRequestError(error) {
            console.error(error.request.responseURL, error);
            return Promise.reject(error);
        });
        this.client.interceptors.response.use(function onResponse(response) {
            if (process.env.SHOW_BROWSER_LOG) {
                console.log(`${response.request.statusText} ${response.request.responseURL}`);
            }
            return response;
        }, function onResponseError(error) {
            console.error(error.request.responseURL, error.response && error.response.data);
            return Promise.reject(error);
        });
    }
    request({ method, url, dataType, data, onProgress, }) {
        return __awaiter(this, void 0, void 0, function* () {
            // const totalFileSizes = Object.keys(params).reduce((totalSize, key) => {
            //   const value = params[key]
            //   if (Array.isArray(value)) {
            //     value.forEach(item => {
            //       if (item instanceof File) {
            //         totalSize += item.size
            //       }
            //     })
            //   } else if (value instanceof File) {
            //     totalSize += value.size
            //   }
            //   return totalSize
            // }, 0)
            //
            // const progress = onProgress && {
            //   current: 0,
            //   total: totalFileSizes || 0
            // }
            // onProgress(progress)
            const progress = onProgress && {
                current: 0,
                total: 0,
            };
            const headers = {};
            let _data;
            switch (dataType) {
                case DataType.Json:
                    _data = data;
                    break;
                case DataType.FormUrlEncoded:
                    _data = toFormUrlEncoded(data);
                    break;
                case DataType.MultipartFormData:
                    _data = toFormData(data);
                    headers['Content-Type'] = 'multipart/form-data';
                    break;
                default:
                    throw new Error('Unknown DataType: ' + dataType);
            }
            const response = yield this.client.request({
                method,
                url,
                data: _data,
                headers,
                onUploadProgress: onProgress && (event => {
                    progress.current = event.loaded;
                    progress.total = event.total || progress.total;
                    onProgress(progress);
                }),
                validateStatus(status) {
                    return true;
                },
            });
            return {
                error: response.status >= 200 && response.status < 300
                    ? void 0
                    : new Error('Invalid status HTTP code: ' + response.status),
                data: response.data,
            };
        });
    }
}
